module.exports = __webpack_public_path__ + "static/media/prev.84bc2d57.svg";